/* eslint-disable no-unused-vars */
/**
 All of the routes for the Material React are added here,
 You can add a new route, customize the routes and delete the routes here.

 Once you add a new route on this file it will be visible automatically on
 the Sidenav.

 For adding a new route you can follow the existing routes in the routes array.
 1. The `type` key with the `collapse` value is used for a route.
 2. The `type` key with the `title` value is used for a title inside the Sidenav.
 3. The `type` key with the `divider` value is used for a divider between Sidenav items.
 4. The `name` key is used for the name of the route on the Sidenav.
 5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
 6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
 7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
 inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
 8. The `route` key is used to store the route location which is used for the react router.
 9. The `href` key is used to store the external links location.
 10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
 10. The `component` key is used to store the component of its route.
 */

// Material React layouts
// import Users from "layouts/dashboards/users";
// import Settings from "layouts/dashboards/settings";
import Videos from "layouts/views/videos";
import VideoPlayer from "components/Videos/VideoPlayer";
import Admin from "layouts/views/admin";
import SafetyDocuments from "layouts/views/safetyDocuments";
import Profile from "layouts/views/profile";
// import AuthPage from "layouts/auth"
// @mui icons
import Icon from "@mui/material/Icon";
import Auth from "./layouts/auth";
import QuizBuilder from "./layouts/views/admin/QuizBuilder";
import TrainingCompletionReport from "./layouts/views/admin/TrainingCompletionReport";
// import QuizPage from "./oldComponents/QuizPage";
import QuizPage from "./components/Quiz";


const routes = [

  // Main Routes
  {
    type: "collapse",
    name: "Home",
    nameEsp: "Casa",
    key: "home",
    route: "/videos",
    icon: <Icon fontSize="medium">videocam</Icon>,
    component: <Videos/>,
    noCollapse: true,
  },
  {
    type: 'collapse',
    name: "Profile",
    nameEsp: "Perfil",
    key: "profile",
    icon: <Icon fontSize="medium">manage_accounts</Icon>,
    route: "/profile",
    component: <Profile/>,
    noCollapse: true,
  },
    {
      type: 'collapse',
      name: "Safety Documents",
      nameEsp: "Documentos de Seguridad",
      key: "safety_document",
      icon: <Icon fontSize="medium">description</Icon>,
      route: "/safety-documents",
      component: <SafetyDocuments/>,
      noCollapse: true,
    },
  {
    name: "Auth",
    key: "auth",
    route: "/auth",
    component: <Auth/>,
    noCollapse: true,
  },
  {
    name: "Quiz Builder",
    key: "quizbuilder",
    route: "/admin/quizbuilder",
    component: <QuizBuilder/>,
    noCollapse: true,
  },
  {
    name: "Quiz",
    key: "quiz",
    route: "/quiz",
    component: <QuizPage/>,
    noCollapse: true,
  },
  {
    name: "Video",
    key: "video",
    route: "/video/:id",
    component: <VideoPlayer/>,
    noCollapse: true,
  },


  // Admin
  {
    type: "collapse",
    name: "Admin",
    key: "admin",
    route: "/admin",
    user: 'Admin',
    icon: <Icon fontSize="medium">admin_panel_settings</Icon>,
    component: <Admin/>,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Training Report",
    key: "training-report",
    route: "/admin/training-report",
    user: 'Admin',
    icon: <Icon fontSize="medium">assignment</Icon>,
    component: <TrainingCompletionReport/>,
    noCollapse: true,
  }

];

export default routes;
